<template>
<!-- <div>ssss</div> -->
  <div>
    <basic-container>
      <div class="page-container partner-manage-page">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <date-range-destructor
                :start.sync="form.createDateBegin"
                :end.sync="form.createDateEnd"
                start-placeholder="创建开始时间"
                end-placeholder="创建结束时间"
                value-format="yyyy-MM-dd"
                type="daterange"
                format = "yyyy-MM-dd">
              </date-range-destructor>
            </el-form-item>
            <el-form-item>
              <el-input clearable v-model="form.keyword" placeholder="合伙人账号/邀请码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-auth="'ACTIVITY_PARTNER_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table
            :data="partnerList"
            :height="autoTableHeight"
            v-loading="listLoading"
            ref="eltable"
            border
            style="width: 100%">
            <el-table-column
              type="index"
              fixed
              label="序号"
              align="center"
              header-align="center"
              width="50">
            </el-table-column>
            <el-table-column
              prop="userAccount"
              align="center"
              header-align="center"
              label="合伙人账号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="inviteCode"
              align="center"
              header-align="center"
              label="邀请码"
              width="180">
            </el-table-column>
            <el-table-column
              prop="deviceBindCount"
              align="center"
              header-align="center"
              label="绑定设备数"
              width="180">
              <template slot-scope="scope">
                <router-link :to="{ path: '/partner/bindDeviceLog', query: { code: scope.row.inviteCode, id: scope.row.userAccount }}">
                 <span class="cell-content">{{scope.row.deviceBindCount}}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="availableAmount"
              align="right"
              header-align="right"
              label="可提现余额（元）"
              width="180">
            </el-table-column>
            <el-table-column
              prop="frozenAmount"
              align="right"
              header-align="right"
              label="冻结金额（元）"
              width="180">
              <template slot-scope="scope">
                <router-link :to="{ path: '/partner/partnerIncomeLog', query: { status: '1', id: scope.row.userAccount }}">
                  <span class="cell-content">{{scope.row.frozenAmount}}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="incomeAmount"
              align="right"
              header-align="right"
              label="总收益金额（元）"
              width="180">
              <template slot-scope="scope">
                <router-link :to="{ path: '/partner/partnerIncomeLog', query: { id: scope.row.userAccount }}">
                  <span class="cell-content">{{scope.row.incomeAmount}}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="withdrawalAmount"
              align="right"
              header-align="right"
              label="累计提现金额（元）"
              width="180">
              <template slot-scope="scope">
                <router-link :to="{ path: '/partner/partnerWithdrawLog', query: { status: '1', id: scope.row.userAccount }}">
                  <span class="cell-content">{{scope.row.withdrawalAmount}}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="idcardNumber"
              align="center"
              header-align="center"
              width="200"
              label="身份证号">
            </el-table-column>                 
            <el-table-column
              prop="createTime"
              align="center"
              header-align="center"
              width="180"
              label="创建时间">
            </el-table-column>
          </el-table>
        </div>
        <div class="table-pagination">
          <TablePagination
            :page-size.sync="pageConfig.size"
            :total="total"
            :current-page.sync="pageConfig.current"
            @change="handlePageChange"
          />
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import { merge } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
  export default {
    name: 'PartnerManagePage',
    mixins: [ListMixins],
    data() {
      return {
        listLoading: false,
        form: {
          keyword: '',
          createDateBegin: '',
          createDateEnd: ''
        },
        times: null,
      }
    },
    computed: {
      ...mapState('partner', ['partnerList', 'total']),
      ...mapGetters('app', ['viewportSize'])
    },
    methods: {
      ...mapActions('partner', ['getPartnerList']),
      getList() {
        const query = merge({}, this.form, this.pageConfig);
        this.listLoading = true;
        this.getPartnerList(query).finally(() => {
          this.listLoading = false;
        });
      }
    },
    created() {
      this.getList();
    }
  }
</script>
<style lang="scss">
  .table-pagination {
    margin-top: 20px;
    text-align: right;
  }
  .partner-manage-page {
    .cell-content {
      color: #008080;
      cursor: pointer;
      text-decoration: underline;
      display: inline-block;
      padding: 6px 10px;
      line-height: 1.3em;
    }
  }
</style>
